export default "<canvas #can></canvas>"